// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21cKf","colMin":"styles_colMin__2eO58"};